webpackJsonp([116155894328964],{

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMailtoLink = exports.toSearchString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toSearchString = exports.toSearchString = function toSearchString() {
	  var searchParams = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createMailtoLink = exports.createMailtoLink = function createMailtoLink(email, headers) {
	  var link = 'mailto:' + email;
	  if (headers) {
	    link += '?' + toSearchString(headers);
	  }
	  return link;
	};
	
	var Mailto = function (_Component) {
	  _inherits(Mailto, _Component);
	
	  function Mailto() {
	    _classCallCheck(this, Mailto);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Mailto).apply(this, arguments));
	  }
	
	  _createClass(Mailto, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props;
	      var email = _props.email;
	      var obfuscate = _props.obfuscate;
	      var headers = _props.headers;
	      var children = _props.children;
	
	      var others = _objectWithoutProperties(_props, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ href: createMailtoLink(email, headers) }, others),
	        children
	      );
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props;
	      var email = _props2.email;
	      var obfuscate = _props2.obfuscate;
	      var headers = _props2.headers;
	      var children = _props2.children;
	
	      var others = _objectWithoutProperties(_props2, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ onClick: this.handleClick.bind(this), href: 'mailto:obfuscated' }, others),
	        children
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props;
	      var email = _props3.email;
	      var headers = _props3.headers;
	
	      window.location.href = createMailtoLink(email, headers);
	    }
	  }]);
	
	  return Mailto;
	}(_react.Component);
	
	Mailto.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  email: _react.PropTypes.string.isRequired,
	  headers: _react.PropTypes.object,
	  obfuscate: _react.PropTypes.bool
	};
	
	Mailto.defaultProps = {
	  obfuscate: false
	};
	
	exports.default = Mailto;

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _sidePhoto = __webpack_require__(74);
	
	var _sidePhoto2 = _interopRequireDefault(_sidePhoto);
	
	var _reactMailto = __webpack_require__(38);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _angleBracket = __webpack_require__(29);
	
	var _angleBracket2 = _interopRequireDefault(_angleBracket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversityPage = function (_Component) {
	  _inherits(UniversityPage, _Component);
	
	  function UniversityPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UniversityPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isNarrowDesktop: (0, _mediaQueries.isNarrowDesktop)(),
	      sideContainerHeight: 0
	    }, _this.handleResize = function () {
	      if (_this.state.isNarrowDesktop !== (0, _mediaQueries.isNarrowDesktop)()) {
	        _this.setState({ isNarrowDesktop: (0, _mediaQueries.isNarrowDesktop)() });
	      }
	      _this.setState({ sideContainerHeight: _this.getHeight() });
	    }, _this.getHeight = function () {
	      if (document && document.body) {
	        return document.body.scrollHeight - 45 - 210;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  UniversityPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.handleResize);
	    }
	    this.setState({ sideContainerHeight: this.getHeight() });
	  };
	
	  UniversityPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  };
	
	  UniversityPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          fontFamily: "'Libre Franklin', 'sans serif'"
	        }
	      },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'IMRD - ' + data.name,
	        meta: [{ name: 'description', content: 'partner university' }, {
	          name: 'keywords',
	          content: 'IMRD, coordinator, contact, general information, parter, partner university, ' + data.name
	        }]
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: { background: '#f7f7f7' } },
	        _react2.default.createElement(
	          _mediaQueries.Desktop,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flex',
	                flexDirection: 'row'
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  maxHeight: this.state.sideContainerHeight,
	                  padding: '2rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '5rem' : '7rem') + ' 2rem 5rem',
	                  width: (0, _mediaQueries.isNarrowDesktop)() ? '67vw' : '55vw'
	                },
	                className: 'scrollable',
	                hidden: this.state.sideContainerHeight === 0
	              },
	              _react2.default.createElement(DefaultUniversity, { data: data })
	            ),
	            _react2.default.createElement(_sidePhoto2.default, {
	              minusHeight: 2.5 * 18,
	              sizes: data.photo.sizes,
	              style: {
	                width: (0, _mediaQueries.isNarrowDesktop)() ? '33vw' : '45vw',
	                overflow: 'hidden'
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  position: 'absolute',
	                  marginTop: 'calc(100vh * .6)',
	                  marginLeft: 'calc(100vw - 240px)'
	                }
	              },
	              _react2.default.createElement(UniversityButton, { link: data.link, image: data.image })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _mediaQueries.Tablet,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                padding: '2rem 4rem'
	              }
	            },
	            _react2.default.createElement(DefaultUniversity, { data: data }),
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '2rem 0', width: 300 } },
	              _react2.default.createElement(UniversityButton, {
	                link: data.link,
	                text: data.name,
	                image: data.image,
	                style: {
	                  padding: '0.5rem 1rem'
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _mediaQueries.Mobile,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                padding: '1rem 2rem'
	              }
	            },
	            _react2.default.createElement(DefaultUniversity, { data: data }),
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '2rem 0' } },
	              _react2.default.createElement(UniversityButton, {
	                link: data.link,
	                text: data.name,
	                image: data.image,
	                style: {
	                  padding: '0.5rem 1rem'
	                }
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return UniversityPage;
	}(_react.Component);
	
	exports.default = UniversityPage;
	
	
	var DefaultUniversity = function DefaultUniversity(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_infoBlock2.default, { title: data.name, text: data.longText.internal.content }),
	    (data.generalInformationAddress || data.coordinatorAddress) && _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginTop: '3rem'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            fontWeight: 600,
	            fontSize: '14px',
	            marginBottom: '1.25rem',
	            lineHeight: 0
	          }
	        },
	        'Contact:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { lineHeight: 1.25, fontSize: '14px' } },
	        data.generalInformationAddress && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'general information:'
	          ),
	          _react2.default.createElement(
	            _reactMailto2.default,
	            {
	              email: data.generalInformationAddress,
	              style: { color: '#549b54' },
	              obfuscate: true
	            },
	            data.generalInformationAddress
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null)
	        ),
	        data.coordinatorAddress && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'coordinator:'
	          ),
	          _react2.default.createElement(
	            _reactMailto2.default,
	            {
	              email: data.coordinatorAddress,
	              style: { color: '#549b54' },
	              obfuscate: true
	            },
	            data.coordinatorAddress
	          )
	        )
	      )
	    )
	  );
	};
	
	var UniversityButton = function UniversityButton(_ref2) {
	  var link = _ref2.link,
	      text = _ref2.text,
	      image = _ref2.image,
	      style = _ref2.style;
	
	  var httpRoute = link;
	  if (link.indexOf('http') === 1) {
	    httpRoute = 'https://' + link;
	  }
	  return _react2.default.createElement(
	    'a',
	    { href: httpRoute },
	    _react2.default.createElement(
	      'div',
	      {
	        style: _extends({
	          background: 'white',
	          minWidth: 240,
	          padding: '0.5rem 4rem 0.5rem 2rem',
	          display: 'flex',
	          alignItems: 'center',
	          justifyContent: 'space-between'
	        }, style),
	        className: 'unselectable card'
	      },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: image.sizes, style: { width: 75, height: 75 } }),
	      text && _react2.default.createElement(
	        'div',
	        null,
	        text
	      ),
	      _react2.default.createElement(_angleBracket2.default, { style: { height: '1rem' } })
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.euUniversityQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(17);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _university = __webpack_require__(110);
	
	var _university2 = _interopRequireDefault(_university);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversityEU = function (_Component) {
	  _inherits(UniversityEU, _Component);
	
	  function UniversityEU() {
	    _classCallCheck(this, UniversityEU);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UniversityEU.prototype.render = function render() {
	    var data = (0, _get2.default)(this, 'props.data.contentfulPartnerUniversityEu');
	    return _react2.default.createElement(_university2.default, { data: data });
	  };
	
	  return UniversityEU;
	}(_react.Component);
	
	exports.default = UniversityEU;
	var euUniversityQuery = exports.euUniversityQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-university-eu-js-4dc92f7136ecc2931812.js